<div class="obavijesti-page">

    <div class="obavijesti-page__container">
        <obavijesti-tablica *ngIf="obavijesti" [obavijesti]="obavijesti"></obavijesti-tablica>
    </div>

</div>